import { ICnicVerification } from "interfaces/Index";
import { convertDateFormat } from "utils/lib";
export const normalizeCnicData = (
  cnicsList: ICnicVerification[]
): ICnicVerification[] => {
  const normalizedCnicsInfo = cnicsList.map((cnicInfo) => {
    const obj = Object.assign({}, cnicInfo, {
      createdAt: convertDateFormat(cnicInfo.createdAt),
      updatedAt: convertDateFormat(cnicInfo.updatedAt),
      status: cnicInfo.verificationStatus,
    });
    return obj;
  });

  return normalizedCnicsInfo;
};
